const hasText = value => typeof value === 'string' && value.trim() !== '';

// Steps that take a fresh AI Agent to "live". `routeName` is where the user
// fixes the step; `null` means it lives outside the Studio (Inboxes settings).
export const buildSetupChecklist = ({
  botConfig = {},
  inboxCount = 0,
  documentCount = 0,
  answerCount = 0,
}) => {
  const persona = botConfig.persona || {};
  const instructions = Array.isArray(botConfig.instructions)
    ? botConfig.instructions
    : [];

  return [
    {
      key: 'PERSONA',
      routeName: 'ai_agents_studio_persona',
      done:
        hasText(persona.system_prompt) ||
        instructions.some(item => item.enabled && hasText(item.content)),
    },
    {
      key: 'KNOWLEDGE',
      routeName: 'ai_agents_studio_knowledge',
      done: documentCount > 0,
    },
    {
      key: 'ANSWERS',
      routeName: 'ai_agents_studio_answers',
      done: answerCount > 0,
    },
    {
      key: 'INBOX',
      routeName: null,
      done: inboxCount > 0,
    },
  ];
};

export const checklistProgress = steps => ({
  done: steps.filter(step => step.done).length,
  total: steps.length,
});
